import React, { useState, useEffect } from "react";
import {
  HashRouter,
  Navigate,
  Route,
  Routes,
  useNavigate,
} from "react-router-dom";
import Sidebar from "./pages/global/Sidebar.jsx";
import { Box, CssBaseline, ThemeProvider } from "@mui/material";
import { ColorModeContext, useMode } from "./theme";
import { ReactSession } from "react-client-session";
import Topbar from "./pages/global/Topbar.jsx";
import Dashboard from "./pages/Dashboard.jsx";
import Voiture from "./pages/Voiture.jsx";
import Etat from "./pages/Etat.jsx";
import Papier from "./pages/Papier.jsx";
import Document from "./pages/Document.jsx";
import Conducteur from "./pages/Conducteur.jsx";
import Contrat from "./pages/Contrat.jsx";
import Paiement from "./pages/Paiement.jsx";
import Charge from "./pages/Charge.jsx";
import AlertComponent from "./pages/AlertComponent.jsx";
import Login from "./pages/Login.jsx";
import PrintContrat from "./pages/PrintContrat.jsx";
import PrintEngagement from "./pages/PrintEngagement.jsx";
import PrintDPLVSC from "./pages/PrintDPLVSC.jsx";
import PrintDAI from "./pages/PrintDAI.jsx";
import "./PrintStyles.css";
import PrintCinPermis from "./pages/PrintCinPermis.jsx";

function MainContent() {
  const [theme, colorMode] = useMode();
  const [loggedIn, setLoggedIn] = useState(false);
  const [isSidebar, setIsSidebar] = useState(true);
  const navigate = useNavigate();
  const username = ReactSession.get("username");

  const handleLogin = () => {
    if (username && username !== "") {
      setLoggedIn(true);
      navigate("/dashboard");
    }
  };

  useEffect(() => {
    // eslint-disable-next-line
    handleLogin();
    // eslint-disable-next-line
  }, [username]);

  return (
    <div className="app">
      <Box sx={{ display: "flex", height: "100vh" }}>
        {loggedIn ? (
          <>
            <Sidebar isSidebar={isSidebar} />
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                flexGrow: 1,
                overflow: "auto",
              }}
            >
              <Topbar setIsSidebar={setIsSidebar} />
              <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
                <main className="content">
                  <Routes>
                    <Route path="/dashboard" element={<Dashboard />} />
                    <Route path="/voiture" element={<Voiture />} />
                    <Route path="/etat" element={<Etat />} />
                    <Route path="/papier" element={<Papier />} />
                    <Route path="/conducteur" element={<Conducteur />} />
                    <Route path="/document" element={<Document />} />
                    <Route path="/contrat" element={<Contrat />} />
                    <Route path="/charge" element={<Charge />} />
                    <Route path="/alert" element={<AlertComponent />} />
                    <Route path="/print-cin-permis/:id" element={<PrintCinPermis />} />
                    <Route
                      path="/print-contrat/:id"
                      element={<PrintContrat />}
                    />
                    <Route
                      path="/print-engagement/:id"
                      element={<PrintEngagement />}
                    />
                    <Route path="/print-dplvsc/:id" element={<PrintDPLVSC />} />
                    <Route path="/print-dai/:id" element={<PrintDAI />} />
                    <Route path="/paiement" element={<Paiement />} />
                    {/* <Route path="/login" element={<Login />} />
                    <Route path="/" element={<Navigate to="/login" />} /> */}
                  </Routes>
                </main>
              </Box>
            </Box>
          </>
        ) : (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              flexGrow: 1,
              overflow: "auto",
            }}
          >
            <main className="content">
              <Routes>
                <Route
                  path="/login"
                  element={
                    <Login
                      onLogin={() => {
                        handleLogin();
                        window.location.reload();
                      }}
                    />
                  }
                />
                <Route path="/*" element={<Navigate to="/login" />} />
              </Routes>
            </main>
          </Box>
        )}
      </Box>
    </div>
  );
}

function App() {
  const [theme, colorMode] = useMode();
  ReactSession.setStoreType("localStorage");

  return (
    <HashRouter>
      <ColorModeContext.Provider value={colorMode}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <MainContent />
        </ThemeProvider>
      </ColorModeContext.Provider>
    </HashRouter>
  );
}

export default App;
